import React, { useEffect, useState,useCallback, Suspense } from "react"; 
//import {getdevicetagsModified,postStatusDashboard, getdevicesMaintenance, getdevicemaintenanceparameter, getOverallMaintenanceUsers, getconfigMaintenance, saveMaintenanceDetails,postMaintenanceDashboard } from  "../../Restclient/datacollection";
import {getdevicetagsModified, overviewHomeApi} from  "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography, Tooltip } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrievalModified from './AssetTagsRetrievalModified';
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LK_Delete from "../../images/LK_Delete";
import OverviewDashboard from './OverviewDashboard';
import TagSelection from './TagSelection';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";


export default function OverviewHomePage() {
  // State for duplicate tag warning
  const [duplicateTagWarning, setDuplicateTagWarning] = useState(false);
    const [viewDashboard, setViewDashboard] = useState(false);
    const [openDashboardDialog, setOpenDashboardDialog] = useState(false);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const themechange = useSelector((state) => state.themedata.theme)
    const [notCreatedMessage, setNotCreatedMessage] = useState('');
    const devicedetailsobject  = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const tagdetailsobject  = useSelector((state) => state.mainpagedata.tagdetailsobject)
    const [showAliasFlag, setShowAliasFlag] = useState(true);
    // API Handler with dialog control
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });
  const [formConfig, setFormConfig] = useState({
    formName: '',
    energyTag: {
      value: '',
      tagid: '',
      tagname: '',
      tagunit: '',
      std_tagname: '',
      tagdatatype: '',
      projectid: '',
      enabled: false
    },
    xParameters: {
      count: 0,
      tags: []
    },
    yParameters: {
      count: 0,
      tags: []
    }
  });

  const [focusedFieldKey, setFocusedFieldKey] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState({});
  const [assetdata, setAssetData] = useState(null);
  const [assetdataerror,setAssetDataError] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]); // Selected tags for 
  const projectname = useSelector((state) => state.mainpagedata.selectedprojectname); 
  const [createdSucess, setCreatedSuccess] = useState(false);
  const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
  const [openAlertRuleNameExceedsLength, setopenAlertRuleNameExceedsLength] = useState(false);
  const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);

  // Prevent duplicate warning from being re-triggered immediately after closing
  const duplicateWarningBlocked = React.useRef(false);

  useEffect(() => {
    if (duplicateTagWarning) {
      duplicateWarningBlocked.current = true;
      return;
    }
    // Only allow duplicate warning to be re-triggered after dialog is closed
    if (duplicateWarningBlocked.current && !duplicateTagWarning) {
      duplicateWarningBlocked.current = false;
      return;
    }
    if (focusedFieldKey && selectedTag?.tagname) {
      // Gather all assigned tagids except the current placeholder
      const assignedTagIds = new Set();
      // Energy Tag
      if (formConfig.energyTag.enabled && !(focusedFieldKey === 'energyTag')) {
        assignedTagIds.add(formConfig.energyTag.tagid);
      }
      // xParameters
      formConfig.xParameters.tags.forEach((tag, idx) => {
        if (tag.enabled && !(focusedFieldKey === `xParameters[${idx}]`)) {
          assignedTagIds.add(tag.tagid);
        }
      });
      // yParameters
      formConfig.yParameters.tags.forEach((tag, idx) => {
        if (tag.enabled && !(focusedFieldKey === `yParameters[${idx}]`)) {
          assignedTagIds.add(tag.tagid);
        }
      });
      // If selectedTag.tagid is already assigned elsewhere, show warning and ignore
      if (assignedTagIds.has(selectedTag.tagid)) {
        setDuplicateTagWarning(true);
        // Do not clear focusedFieldKey or selectedTag here; let user close dialog first
        return;
      }
      // Otherwise, assign as usual
      if (focusedFieldKey === 'energyTag') {
        setFormConfig(prev => ({
          ...prev,
          energyTag: {
            value: selectedTag.tagname,
            tagid: selectedTag.tagid,
            tagname: selectedTag.tagname,
            tagunit: selectedTag.tagunit,
            std_tagname: selectedTag.std_tagname,
            tagdatatype: selectedTag.tagdatatype,
            projectid: selectedTag.projectid,
            enabled: true
          }
        }));
      } else if (focusedFieldKey.startsWith('xParameters[')) {
        const index = parseInt(focusedFieldKey.match(/\[(\d+)\]/)[1]);
        setFormConfig(prev => {
          const updated = { ...prev };
          updated.xParameters.tags[index] = {
            value: selectedTag.tagname,
            tagid: selectedTag.tagid,
            tagname: selectedTag.tagname,
            tagunit: selectedTag.tagunit,
            std_tagname: selectedTag.std_tagname,
            tagdatatype: selectedTag.tagdatatype,
            projectid: selectedTag.projectid,
            enabled: true
          };
          return updated;
        });
      } else if (focusedFieldKey.startsWith('yParameters[')) {
        const index = parseInt(focusedFieldKey.match(/\[(\d+)\]/)[1]);
        setFormConfig(prev => {
          const updated = { ...prev };
          updated.yParameters.tags[index] = {
            value: selectedTag.tagname,
            tagid: selectedTag.tagid,
            tagname: selectedTag.tagname,
            tagunit: selectedTag.tagunit,
            std_tagname: selectedTag.std_tagname,
            tagdatatype: selectedTag.tagdatatype,
            projectid: selectedTag.projectid,
            enabled: true
          };
          return updated;
        });
      }
      setFocusedFieldKey(null);
      setSelectedTag(null);
    }
  }, [selectedTag, focusedFieldKey, formConfig.energyTag, formConfig.xParameters.tags, formConfig.yParameters.tags, duplicateTagWarning]);

  // When dialog closes, also clear focusedFieldKey and selectedTag to allow new selection
  const handleCloseDuplicateTagWarning = () => {
    setDuplicateTagWarning(false);
    setFocusedFieldKey(null);
    setSelectedTag(null);
  };

   const assetcallback = (res) => {
        console.log("res obtd in assetscallback in OverviewHomePage",res)
        if(res.success == true){
            setAssetData({devices: res.devices});
        }else{
            setAssetData({devices: {}});
        }
    };

    useEffect(() => {
        getdevicetagsModified(assetcallback)
    }, [selectedprojectname]);

  // Handle form name change
  function handleFormNameChange(value) {
    setFormConfig(prev => ({
      ...prev,
      formName: value
    }));
  }

  // Handle focus on tag input fields
  const handleTagFieldFocus = (fieldKey) => {
    // Only allow focusing a placeholder if a tag is already selected
    if (!selectedTag || !selectedTag.tagname) {
      // Optionally, show a warning or ignore silently
      return;
    }
    setFocusedFieldKey(fieldKey);
    console.log("Focused field:", fieldKey);
  };

  // Handle tag field value change
  const handleTagFieldChange = (fieldKey, value) => {
    if (fieldKey === 'energyTag') {
      setFormConfig(prev => ({
        ...prev,
        energyTag: {
          ...prev.energyTag,
          value: value
        }
      }));
    } else if (fieldKey.startsWith('xParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.xParameters.tags[index] = {
          ...updated.xParameters.tags[index],
          value: value
        };
        return updated;
      });
    } else if (fieldKey.startsWith('yParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.yParameters.tags[index] = {
          ...updated.yParameters.tags[index],
          value: value
        };
        return updated;
      });
    }
    setSelectedTag(null);
  };

  function handleViewDashboard(){
        setViewDashboard(true);
    }

  function isValidLength(value, minLength, maxLength) {
      return value.length >= minLength && value.length <= maxLength;
  }
  function containsSpacesOrSpecialChars(str) {
      // Allow spaces and underscores, but reject other special characters
      return /[^\w\s]/.test(str);
  }

  function handleAlertRuleNameExceedsLength(){
        setopenAlertRuleNameExceedsLength(false)
    }

  
    const handleConfigureDashboard = () => {
        setOpenDashboardDialog(true);
    }
  // Handle Asset parameter count change
  const handleXParameterCountChange = (count) => {
    const newCount = Math.max(0, Math.min(20, count));
    setFormConfig(prev => {
      const newTags = [...prev.xParameters.tags];
      
      // Add new empty tags if count increased
      while (newTags.length < newCount) {
        newTags.push({
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        });
      }
      
      // Remove tags if count decreased
      while (newTags.length > newCount) {
        newTags.pop();
      }

      return {
        ...prev,
        xParameters: {
          count: newCount,
          tags: newTags
        }
      };
    });
  };

  // Handle Department parameter count change
  const handleYParameterCountChange = (count) => {
    const newCount = Math.max(0, Math.min(20, count));
    setFormConfig(prev => {
      const newTags = [...prev.yParameters.tags];
      
      // Add new empty tags if count increased
      while (newTags.length < newCount) {
        newTags.push({
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        });
      }
      
      // Remove tags if count decreased
      while (newTags.length > newCount) {
        newTags.pop();
      }

      return {
        ...prev,
        yParameters: {
          count: newCount,
          tags: newTags
        }
      };
    });
  };

  // Handle tag field clear
  const handleClearTagField = (fieldKey) => {
    if (fieldKey === 'energyTag') {
      setFormConfig(prev => ({
        ...prev,
        energyTag: {
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        }
      }));
    } else if (fieldKey.startsWith('xParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.xParameters.tags[index] = {
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        };
        return updated;
      });
    } else if (fieldKey.startsWith('yParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.yParameters.tags[index] = {
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        };
        return updated;
      });
    }
  };

  // Render energy tag configuration field
  const renderEnergyTagField = () => {
    const tag = formConfig.energyTag;
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px',
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: tag.enabled ? 'rgba(76, 175, 80, 0.1)' : 'transparent'
      }}>
        <span style={{ 
          minWidth: '120px', 
          fontSize: '16px',
          fontWeight: tag.enabled ? 600 : 400,
          color: '#666'
        }}>
          Energy Tag:
        </span>
        <Tooltip
          title={(() => {
            const tagObj = tagdetailsobject[tag.tagid];
            const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
            const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
            const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
            return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
          })()}
          arrow
          placement="top"
        >
          <TextField
            className="textfield"
            variant="standard"
            value={(() => {
              const tagObj = tagdetailsobject[tag.tagid];
              const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
              const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
              const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
              return `${deviceName}: ${showAliasFlag ? alias : name}`;
            })()}
            placeholder="Select tag"
            onFocus={() => handleTagFieldFocus('energyTag')}
            onChange={(e) => handleTagFieldChange('energyTag', e.target.value)}
            onKeyDown={e => e.preventDefault()}
            sx={{
              marginLeft: "16px",
              marginTop: "0px",
              fontSize: "16px",
              fontFamily: "Roboto",
              marginLeft: "14px",
              '& .MuiInputBase-input:focus': { color: '#008CD7' },
              '& .MuiInputBase-root': {
                fontFamily: 'Roboto',
                fontSize: '16px',
                fontWeight: '700',
                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
              },
              '& .MuiInputBase-root::before': {
                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottom: '2px solid #008CD7',
              },
              '& .MuiInputBase-root::after': {
                borderBottom: '2px solid #008CD7',
              },
            }}
          />
        </Tooltip>
        {tag.enabled && (
          <>
            <span style={{
              backgroundColor: '#1976d2',
              color: 'white',
              padding: '4px 8px',
              borderRadius: '12px',
              fontSize: '12px'
            }}>
              {tag.tagunit}
            </span>
            <button
              onClick={() => handleClearTagField('energyTag')}
              style={{
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 10px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              ×
            </button>
          </>
        )}
      </div>
    );
  };

  // Render Asset parameter configuration fields
  const renderXParameterFields = () => {
    return (
      <div style={{ marginTop: '20px' }}>
        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Top Guzzlers: Configure Assets Consumption({formConfig.xParameters.tags.filter(tag => tag.enabled).length} / {formConfig.xParameters.count} configured)</Typography>
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Number of Assets:</Typography>
          <button 
            onClick={() => handleXParameterCountChange(formConfig.xParameters.count - 1)}
            disabled={formConfig.xParameters.count === 0}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.xParameters.count === 0 ? 0.5 : 1
            }}
          >
            -
          </button>
          <TextField
            className="textfield"
            variant="standard"
            type="number"
            value={formConfig.xParameters.count}
            onChange={(e) => handleXParameterCountChange(parseInt(e.target.value) || 0)}
            min="0"
            max="20"
             sx={{
                marginLeft:"16px",
                marginTop:"0px",
                fontSize:"16px",
                fontFamily:"Roboto",
                marginLeft:"14px",
                '& .MuiInputBase-input:focus': { color: '#008CD7' },
                '& .MuiInputBase-root': {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '700',
                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                },
                '& .MuiInputBase-root::before': {
                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid #008CD7',
                },
                '& .MuiInputBase-root::after': {
                    borderBottom: '2px solid #008CD7',
                },
                }}
          />
          <button 
            onClick={() => handleXParameterCountChange(formConfig.xParameters.count + 1)}
            disabled={formConfig.xParameters.count >= 20}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.xParameters.count >= 20 ? 0.5 : 1
            }}
          >
            +
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
          {formConfig.xParameters.tags.map((tag, index) => (
            <div key={index} style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: tag.enabled ? 'rgba(25, 118, 210, 0.1)' : 'transparent'
            }}>
              <span style={{ 
                minWidth: '80px', 
                fontSize: '14px',
                fontWeight: tag.enabled ? 600 : 400,
                color: '#666'
              }}>
                Asset {index + 1} Tag:
              </span>
              <Tooltip
                title={(() => {
                  const tagObj = tagdetailsobject[tag.tagid];
                  const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                  const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value !== '' ? "(No Alias)" : '');
                  const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value !== '' ? "(No Name)" : '');
                  return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
                })()}
                arrow
                placement="top"
              >
                <TextField
                  className="textfield"
                  variant="standard"
                  type="text"
                  value={(() => {
                    const tagObj = tagdetailsobject[tag.tagid];
                    const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                    const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value !== '' ? "(No Alias)" : '');
                    const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value !== '' ? "(No Name)" : '');
                    return `${deviceName}: ${showAliasFlag ? alias : name}`;
                  })()}
                  placeholder="Select tag"
                  onFocus={() => handleTagFieldFocus(`xParameters[${index}]`)}
                  onChange={(e) => handleTagFieldChange(`xParameters[${index}]`, e.target.value)}
                  onKeyDown={e => e.preventDefault()}
                  sx={{
                    marginLeft: "16px",
                    marginTop: "0px",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    marginLeft: "14px",
                    '& .MuiInputBase-input:focus': { color: '#008CD7' },
                    '& .MuiInputBase-root': {
                      fontFamily: 'Roboto',
                      fontSize: '16px',
                      fontWeight: '700',
                      color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                    },
                    '& .MuiInputBase-root::before': {
                      borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: '2px solid #008CD7',
                    },
                    '& .MuiInputBase-root::after': {
                      borderBottom: '2px solid #008CD7',
                    },
                  }}
                />
              </Tooltip>
              {tag.enabled && (
                <>
                  <span style={{
                    backgroundColor: '#1976d2',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '12px'
                  }}>
                    {tag.tagunit}
                  </span>
                  <button
                    onClick={() => handleClearTagField(`xParameters[${index}]`)}
                    style={{
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 10px',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render Department parameter configuration fields
  const renderYParameterFields = () => {
    return (
      <div style={{ marginTop: '20px' }}>
         <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Top Guzzlers: Configure Departments Consumption ({formConfig.yParameters.tags.filter(tag => tag.enabled).length} / {formConfig.yParameters.count} configured)</Typography>
        
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Number of Departments:</Typography>
          <button 
            onClick={() => handleYParameterCountChange(formConfig.yParameters.count - 1)}
            disabled={formConfig.yParameters.count === 0}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.yParameters.count === 0 ? 0.5 : 1
            }}
          >
            -
          </button>
          <TextField
            className="textfield"
            variant="standard"
            type="number"
            value={formConfig.yParameters.count}
            onChange={(e) => handleYParameterCountChange(parseInt(e.target.value) || 0)}
            min="0"
            max="20"
             sx={{
                marginLeft:"16px",
                marginTop:"0px",
                fontSize:"16px",
                fontFamily:"Roboto",
                marginLeft:"14px",
                '& .MuiInputBase-input:focus': { color: '#008CD7' },
                '& .MuiInputBase-root': {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '700',
                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                },
                '& .MuiInputBase-root::before': {
                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid #008CD7',
                },
                '& .MuiInputBase-root::after': {
                    borderBottom: '2px solid #008CD7',
                },
                }}
          />
          <button 
            onClick={() => handleYParameterCountChange(formConfig.yParameters.count + 1)}
            disabled={formConfig.yParameters.count >= 20}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.yParameters.count >= 20 ? 0.5 : 1
            }}
          >
            +
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
          {formConfig.yParameters.tags.map((tag, index) => (
            <div key={index} style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor:tag.enabled ? 'rgba(25, 118, 210, 0.1)' : 'transparent'
            }}>
              <span style={{ 
                minWidth: '80px', 
                fontSize: '14px',
                fontWeight: tag.enabled ? 600 : 400,
                color: '#666'
              }}>
                Department {index + 1} Tag:
              </span>
              <Tooltip
                title={(() => {
                  const tagObj = tagdetailsobject[tag.tagid];
                  const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                  const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                  const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                  return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
                })()}
                arrow
                placement="top"
              >
                <TextField
                  className="textfield"
                  variant="standard"
                  type="text"
                  value={(() => {
                    const tagObj = tagdetailsobject[tag.tagid];
                    const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                    const alias = tagObj && tagObj.Alias ? tagObj.Alias :(tag.value != '')?"(No Alias)":'';
                    const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                    return `${deviceName}: ${showAliasFlag ? alias : name}`;
                  })()}
                  placeholder="Select tag"
                  onFocus={() => handleTagFieldFocus(`yParameters[${index}]`)}
                  onChange={(e) => handleTagFieldChange(`yParameters[${index}]`, e.target.value)}
                  onKeyDown={e => e.preventDefault()}
                  sx={{
                    marginLeft: "16px",
                    marginTop: "0px",
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    marginLeft: "14px",
                    '& .MuiInputBase-input:focus': { color: '#008CD7' },
                    '& .MuiInputBase-root': {
                      fontFamily: 'Roboto',
                      fontSize: '16px',
                      fontWeight: '700',
                      color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                    },
                    '& .MuiInputBase-root::before': {
                      borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                      borderBottom: '2px solid #008CD7',
                    },
                    '& .MuiInputBase-root::after': {
                      borderBottom: '2px solid #008CD7',
                    },
                  }}
                />
              </Tooltip>
              {tag.enabled && (
                <>
                  <span style={{
                    backgroundColor: '#1976d2',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '12px'
                  }}>
                    {tag.tagunit}
                  </span>
                  <button
                    onClick={() => handleClearTagField(`yParameters[${index}]`)}
                    style={{
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 10px',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  function handleSaveChange(){

  }

   const handleCloseConfigureDashboard = () => {
        setOpenDashboardDialog(false);
        // Reset all relevant state to initial values
        setFormConfig({
          formName: '',
          energyTag: {
            value: '',
            tagid: '',
            tagname: '',
            tagunit: '',
            std_tagname: '',
            tagdatatype: '',
            projectid: '',
            enabled: false
          },
          xParameters: {
            count: 0,
            tags: []
          },
          yParameters: {
            count: 0,
            tags: []
          }
        });
        setSelectedTag(null);
        setFocusedFieldKey(null);
        // setSelectedAsset({});
        // setAssetData(null);
        setAssetDataError(false);
        setSelectedTags([]);
        setShowAliasFlag(true);
        //setExistingDeviceTagAlarmConfig(false);
    }

    function handleCancelViewDashboard(){
        setViewDashboard(false);
    }

     const handleCloseCreateDashboard = useCallback(() => {
        setCreatedSuccess(false)
    }, []);

    const handleCloseNotCreateDashboard = useCallback(() => {
        setNotCreatedSuccess(false)
    }, []);

  async function handleSaveConfiguration() {
    // Save the complete form configuration
    const filteredEnergyTag = formConfig.energyTag.enabled ? formConfig.energyTag : null;
    const filteredXParameters = formConfig.xParameters.tags.filter(tag => tag.enabled);
    const filteredYParameters = formConfig.yParameters.tags.filter(tag => tag.enabled);
    const assetTagCount = filteredXParameters.length + filteredYParameters.length;
    if (!filteredEnergyTag) {
      setNotCreatedMessage("Energy Tag is required.");
      setNotCreatedSuccess(true);
      return;
    }
    if (assetTagCount < 2) {
      setNotCreatedMessage("At least 2 asset tags are required.");
      setNotCreatedSuccess(true);
      return;
    }
    const configuredData = {
      formName: formConfig.formName,
      energyTag: filteredEnergyTag,
      xParameters: filteredXParameters,
      yParameters: filteredYParameters
    };

    if((!isValidLength(formConfig.formName,5,30)) || (containsSpacesOrSpecialChars(formConfig.formName))){
        setopenAlertRuleNameExceedsLength(true)
        return;
      }

    const payload = {
      dashboardName: formConfig.formName,
      configuredData: configuredData,
      projectId: userdetails.Projectid === "All" ? selectedprojectname : userdetails.Projectid,
      organizationId: userdetails.Organizationid,
      action:"CREATE",
      dashboard_pro:null,
    };

    await callApi(
      () => overviewHomeApi.createDashboard(payload),
      {
        showDialog: false,
        hideDialogOnStatusCodes: [404],
        showDialogOnCatch: false,  // Don't show dialog for catch errors, handle manually
        useBackendMessage: true,
        onSuccess: (response) => {
          console.log("Dashboard Overview created successfully:", response);
          if (response.data.success && response.data.data && response.data.data.data) {
            setCreatedSuccess(true);
            setOpenDashboardDialog(false);
          } else {
            setNotCreatedMessage(response.data.message || "Failed to create dashboard");
            setNotCreatedSuccess(true);
            setOpenDashboardDialog(false);
          }
        },
        onError: (error) => {
          console.error("Error creating dashboard:", error);
          setNotCreatedMessage(error?.message || "Failed to create dashboard");
          setNotCreatedSuccess(true);
          setOpenDashboardDialog(false);
        },
        onCatchError: (error, errorInfo) => {
          // Handle unexpected errors (network failures, exceptions, etc.)
          console.error("Unexpected error creating dashboard:", error, errorInfo);
          setNotCreatedMessage(error?.message || "Network error or unexpected failure. Please try again.");
          setNotCreatedSuccess(true);
          setOpenDashboardDialog(false);
        }
      }
    );
    }
   return (
          <>
            {/* Duplicate tag warning dialog */}
            <CustomDialogBox
              dialogTitle={"Duplicate Tag Assignment"}
              dialogText={"You cannot assign the same tag to multiple placeholders. Please select a different tag."}
              openDialog={duplicateTagWarning}
              handleCloseDialog={handleCloseDuplicateTagWarning}
              handleConfirmDialog={handleCloseDuplicateTagWarning}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Error"}
            />
              {(viewDashboard == false) &&  
                          <Box className="parentDiv" style={{width: "100%",boxSizing: 'border-box'}}>
                              <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                  {/*<Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"10px"}}>Select Device to configure Scheduled and Condition Based Maintenance</Typography>*/}
                                  <Box sx={{flexGrow:1}}></Box>
                                  {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                                  <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                                      <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                          <CustomButton /*id={assetInfo.id}*/ onClick={handleViewDashboard} buttonText={'View Dashboard'} width={'200px'} />
                                          <CustomButton /*id={assetInfo.id}*/ onClick={handleConfigureDashboard} buttonText={'Configure Dashboard'} width={'200px'} />
                                      </Box> 
                                  </div>
                                  <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                                      <CustomButton onClick={handleSaveChange} buttonText={'Save'} width={'120px'} />
                                  </div>
                              </Box>
                               <Dialog
                                  open={openDashboardDialog}
                                  onClose={handleCloseConfigureDashboard}
                                  fullWidth
                                  maxWidth="xl"
                                  BackdropProps={{
                                      sx: {
                                          backgroundColor: themechange === 'light' ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)',
                                      },
                                  }}
                                  sx={{
                                      "& .MuiDialog-paper": {
                                          height: "85vh",
                                          width: "100%",
                                          borderTopLeftRadius: "40px",
                                          borderTopRightRadius: "40px",
                                          overflow: "auto",
                                          backgroundColor: themechange === 'light' ? "#FFFFFF" : "#19191B",
                                      },
                                  }}
                              >
                                  <DialogTitle
                                      sx={{
                                          color: "#FFFFFF",
                                          backgroundColor: "#005C8E",
                                          margin: "5px",
                                          borderRadius: "100px",
                                      }}
                                  >
                                      Configure Dashboard
                                  </DialogTitle>
                                  <DialogContent
                                      sx={{
                                          width: "98%",
                                          height: "100%",
                                          backgroundColor: 'var(--secondary-backgroundLK)',
                                          overflow: "auto",
                                          position: "relative",
                                      }}
                                  >
                                    
                                           <Typography sx={{paddingLeft: '48px',fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px",fontStyle: "italic" }}>{"Note: Empty placeholders will be ignored."}</Typography>
                                             
                                          <div style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
                                            <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>{"Enter Summary Dashboard Name"}</Typography>
                                            
                                            {/* Form Name Configuration */}
                                            <div style={{ marginBottom: '30px' }}>
                                                
                                            {/* Validation helpers for form name */}
                                            {(() => {
                                              function isValidLength(value, minLength, maxLength) {
                                                return value.length >= minLength && value.length <= maxLength;
                                              }
                                              function containsSpacesOrSpecialChars(str) {
                                                // Allow spaces and underscores, but reject other special characters
                                                return /[^\w\s]/.test(str);
                                              }
                                              return (
                                                <TextField
                                                  label=""
                                                  value={formConfig.formName}
                                                  variant="standard"
                                                  onChange={(e) => handleFormNameChange(e.target.value)}
                                                  required
                                                  inputProps={{ minLength: 5, maxLength: 30 }}
                                                  placeholder="Enter form name"
                                                  helperText={
                                                    formConfig.formName.length > 0 &&
                                                    (!isValidLength(formConfig.formName, 5, 30) || containsSpacesOrSpecialChars(formConfig.formName))
                                                      ? `Length must be between 5 and 30 characters. Only letters, numbers, spaces, and underscores are allowed. ${formConfig.formName.length}/30 characters used`
                                                      : `${formConfig.formName.length}/30 characters used`
                                                  }
                                                  FormHelperTextProps={{
                                                    sx: {
                                                      color: (formConfig.formName.length > 0 && (!isValidLength(formConfig.formName, 5, 30) || containsSpacesOrSpecialChars(formConfig.formName)))
                                                        ? '#DC272D'
                                                        : '#00943D'
                                                    }
                                                  }}
                                                  sx={{
                                                    width: '400px',
                                                    padding: '0px',
                                                    '& .MuiInputBase-input:focus': {
                                                      color: '#008CD7',
                                                    },
                                                    '& .MuiInputBase-root': {
                                                      fontFamily: 'Roboto',
                                                      fontSize: '16px',
                                                      fontWeight: '700',
                                                      color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                    },
                                                    '& .MuiInput-root .MuiInputBase-input': {},
                                                    '& .MuiInputBase-root::before': {
                                                      borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                    },
                                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                      borderBottom: '2px solid #008CD7',
                                                    },
                                                    '& .MuiInputBase-root::after': {
                                                      borderBottom: '2px solid #008CD7',
                                                    },
                                                  }}
                                                />
                                              );
                                            })()}
                                            </div>

                                            {/* Energy Tag Configuration */}
                                            <div style={{ marginBottom: '30px' }}>
                                                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:themechange === 'light' ? '#7e7e7e' : '#c1c1c1', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Energy Tag Configuration</Typography>
                                                {renderEnergyTagField()}
                                            </div>

                                            {/* Main Content Layout */}
                                            <div style={{ display: 'flex', flexDirection: 'row', gap: '40px' }}>
                                                <div style={{ marginTop: '65px' }}>
                                                {/* Asset Tags Retrieval Component */}
                                                <AssetTagsRetrievalModified 
                                                  assetdata={assetdata} 
                                                  setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                                  setSelectedTag={setSelectedTag} 
                                                  selectedTag={selectedTag}
                                                  setSelectedAsset={setSelectedAsset} 
                                                  setShowAliasFlag={setShowAliasFlag}
                                                />
                                                </div>
                                                <div style={{ flex: 1 }}>
                                                {/* Render Parameter Configuration Fields */}
                                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                                                    <div>
                                                    {renderXParameterFields()}
                                                    </div>
                                                    <div>
                                                    {renderYParameterFields()}
                                                    </div>
                                                </div>
                                                </div>
                                            </div>

                                            {/* Configuration Summary and Save Button */}
                                            {/* <div style={{ 
                                                marginTop: '40px',
                                                padding: '20px',
                                                backgroundColor: '#f5f5f5',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd'
                                            }}>
                                                <h3 style={{ color: '#333', marginBottom: '15px' }}>Configuration Summary</h3>
                                                
                                                <div style={{ marginBottom: '10px' }}>
                                                <strong>Energy Tag:</strong> {formConfig.energyTag.enabled ? `✓ ${formConfig.energyTag.tagname}` : '✗ Not configured'}
                                                </div>
                                                <div style={{ marginBottom: '10px' }}>
                                                <strong>Asset Parameters:</strong> {formConfig.xParameters.tags.filter(tag => tag.enabled).length} / {formConfig.xParameters.count} configured
                                                </div>
                                                <div style={{ marginBottom: '20px' }}>
                                                <strong>Department Parameters:</strong> {formConfig.yParameters.tags.filter(tag => tag.enabled).length} / {formConfig.yParameters.count} configured
                                                </div>
                                                
                                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                 <button
                                                    onClick={handleSaveConfiguration}
                                                    style={{
                                                    backgroundColor: '#005C8E',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '20px',
                                                    padding: '12px 32px',
                                                    fontSize: '16px',
                                                    cursor: 'pointer',
                                                    fontWeight: '500'
                                                    }}
                                                >
                                                    Save Configuration
                                                </button>
                                                </div>
                                            </div> */}
                                            </div>
                                      
                                  </DialogContent>
                                  <DialogActions sx={{ justifyContent: 'center' }}>
                                      <Button
                                          onClick={handleSaveConfiguration}
                                          sx={{
                                              outline: 'none !important',
                                              boxShadow: 'none',
                                              height: '35px',
                                              width: '125px',
                                              fontSize: '16px',
                                              textTransform: 'capitalize',
                                              marginRight: '5px',
                                              backgroundColor: '#005C8E',
                                              borderRadius: '20px',
                                          }}
                                          variant="contained"
                                          autoFocus
                                      >
                                          Create
                                      </Button>
                                      <CustomCancelButton onClick={handleCloseConfigureDashboard} buttonText={'Cancel'} />
                                  </DialogActions>
                              </Dialog>
                          </Box>}
              {(viewDashboard == true) && 
                          <Suspense fallback={<div>Loading Dashboard...</div>}>
                                  <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box", width:"100%" }}>
                                      <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                                          <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                              <Box sx={{flexGrow:1}}></Box>
                                              <CustomCancelButton onClick={handleCancelViewDashboard} buttonText={'Cancel'}></CustomCancelButton>
                                          </Box>
                                          <OverviewDashboard />
                                      </Box>
                                  </Box>
                          </Suspense>}
                           <CustomDialogBox dialogTitle={"Created Dashboard Successfully"} dialogText={"Dashboard Successfully created "}  openDialog={createdSucess}  handleCloseDialog={handleCloseCreateDashboard}  handleConfirmDialog={handleCloseCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
                           <CustomDialogBox dialogTitle={"Created Dashboard Failed"} dialogText={notCreatedMessage ||"Failed to create dashboard .Try Again! "}  openDialog={notCreatedSuccess}  handleCloseDialog={handleCloseNotCreateDashboard}  handleConfirmDialog={handleCloseNotCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                           <CustomDialogBox dialogTitle={"Creation of Dashboard Failed"} dialogText={"Check if Dashboard Name has length between 5-30 characters and no special characters"}  openDialog={openAlertRuleNameExceedsLength}  handleCloseDialog={handleAlertRuleNameExceedsLength}  handleConfirmDialog={handleAlertRuleNameExceedsLength}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
          </>
          
      )
//   return (

//   );
}